import React from 'react';

export const ConnectorsView: React.FC = () => {
    return <p>ConnectorsView</p>;
};
